// import React, { useState, useEffect, useContext } from 'react';

// //styles
// import styles from './EditeGroup.module.scss';
// import copyStyleNewUser from '../../../shared/NewUserModal.module.scss';

// //context
// import { myUserDataContext } from '../../../App';

// //functions
// import { responseHandler } from '../../../functions/responseHandler';
// import { notify } from '../../../functions/toasts';
// import { Select } from 'antd';
// import 'react-toastify/dist/ReactToastify.css';

// //dependency
// import { useParams, useNavigate } from 'react-router-dom';
// import axios from 'axios';

// //components
// import Loading from '../../../shared/Loading';

// import { debounce } from 'lodash';
// import CustomSelect from 'react-select';

// const EditeGroup = () => {
//   const params = useParams();
//   const navigate = useNavigate();

//   const data = useContext(myUserDataContext);
//   const {
//     userData,
//     UpdateLocalStorage,
//     setUpdateLocalStorage,
//     isLogin,
//   } = data;
//   const { token } = userData;

//   //a copy of userData in database

//   const [checkBtnEdite, setCheckBtnEdite] = useState(false);
//   const [isLoad, setIsLoad] = useState(true);

//   const [title, setTitle] = useState('');
//   const [selectedUsers, setSelectedUsers] = useState([]);
//   const [users, setUsers] = useState([]);
//   const [selectedUserOptions, setSelectedUserOptions] = useState([]);

//   const fetchUsers = async (name = '') => {
//     try {
//       const url = name
//         ? `/user/list-for-select?last_name=${encodeURIComponent(name)}`
//         : `/user/list-for-select`;

//       const res = await axios.get(url, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       if (res.data.status) {
//         const options = res.data.data.map((item) => ({
//           label: item.last_name,
//           value: item.id,
//         }));
//         setUsers(options);
//       }
//     } catch (err) {
//       responseHandler(err, 'error');
//     }
//   };

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   const debouncedFetchUsers = debounce((value) => {
//     if (value.length >= 2) {
//       fetchUsers(value);
//     }
//   }, 500);

//   const handleInputChangeUser = (value) => {
//     debouncedFetchUsers(value);
//   };

//   const handleChangeUser = (selectedOption) => {
//     const opts = selectedOption || [];
//     setSelectedUserOptions(opts);
//     setSelectedUsers(opts.map((o) => o.value)); // فقط idها برای ارسال
//   };

//   //for get data of user for Edite
//   useEffect(() => {
//     const runGet = async () => {
//       await axios
//         .get(`/access-group/show/${params.id}?relations[]=users`, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         })
//         .then((res) => {
//           if (res.data.status) {
//             setTitle(res.data.data.title);
//             const usersSelected = res.data.data.users.map(
//               (user) => user.id,
//             );
//             setSelectedUsers(usersSelected);
//           }
//         })
//         .catch((error) => {
//           responseHandler(error, 'error', false);
//           if (error.response?.status === 404)
//             navigate('/notfound', { replace: true });
//         });
//     };

//     runGet();
//   }, []);

//   useEffect(() => {
//     if (!users.length) return;
//     if (!selectedUsers.length) {
//       setSelectedUserOptions([]);
//       return;
//     }

//     const preSelected = users.filter((opt) =>
//       selectedUsers.includes(opt.value),
//     );
//     setSelectedUserOptions(preSelected);
//   }, [users, selectedUsers]);

//   const inputHandler = (e) => {
//     setTitle(e.target.value);
//   };

//   //for select of role handler

//   //for click on edite btn
//   const editeUserHandler = async () => {
//     setCheckBtnEdite(true);

//     if (title === '' || selectedUsers.length === 0) {
//       notify('برخی از موارد خواسته شده وارد نشده اند', 'error');
//       setCheckBtnEdite(false);
//       return;
//     }

//     const bodyUpdateGroup = {
//       title: title,
//       users: selectedUsers,
//     };

//     await axios
//       .put(`/access-group/update/${params.id}`, bodyUpdateGroup, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       })
//       .then((res) => {
//         responseHandler(res, 'succ');
//         if (res.data.status) {
//           axios
//             .get(`/access-group/show/${params.id}`, {
//               headers: { Authorization: `Bearer ${token}` },
//             })
//             .then((res) => {
//               if (res.data.status) {
//                 setUpdateLocalStorage(!UpdateLocalStorage);
//                 navigate('/dashboard/groups');
//               }
//             })
//             .catch((error) => {
//               responseHandler(error, 'error');
//               setIsLoad(false);
//               setCheckBtnEdite(false);
//             });

//           setIsLoad(false);
//         }

//         setCheckBtnEdite(false);
//       })
//       .catch((error) => {
//         responseHandler(error, 'error');
//         setCheckBtnEdite(false);
//       });
//   };

//   //for style role label
//   const roleStyle = {
//     display: 'flex',
//     justifyContent: 'flex-start',
//     margin: '8px 0',
//     backgroundColor: '#e3242b',
//     color: '#fff',
//     display: 'inline-block',
//     padding: '0.1rem 0.6rem',
//     borderRadius: '4px',
//   };

//   return isLogin ? (
//     <>
//       <div className={styles.EditeUserDiv}>
//         <div className={styles.title}>
//           <span>{`ویرایش ${title}`}</span>
//           <i className="bi bi-person-fill-gear"></i>
//         </div>

//         <>
//           <div className={styles.InputsDiv}>
//             <div className={copyStyleNewUser.Inputs}>
//               <label htmlFor="nameEdite">نام:</label>
//               <input
//                 type="text"
//                 id="nameEdite"
//                 name="title"
//                 value={title}
//                 onChange={inputHandler}
//               />
//             </div>

//             {users?.length > 0 && (
//               <div>
//                 <div
//                   style={{
//                     marginBottom: 200,
//                   }}
//                 >
//                   <CustomSelect
//                     isMulti
//                     options={users}
//                     value={selectedUserOptions}
//                     placeholder="کاربر را انتخاب کنید"
//                     onInputChange={handleInputChangeUser}
//                     onChange={handleChangeUser}
//                     isClearable
//                     isSearchable
//                   />
//                 </div>
//               </div>
//             )}
//           </div>

//           <div
//             className={`${styles.btns} d-grid gap-2 col-6 mx-auto mt-5`}
//           >
//             <button
//               className="btn btn-primary"
//               disabled={checkBtnEdite}
//               onClick={editeUserHandler}
//             >
//               ویرایش
//               {checkBtnEdite && (
//                 <span
//                   className="spinner-border spinner-border-sm me-2"
//                   role="status"
//                   aria-hidden="true"
//                 ></span>
//               )}
//             </button>
//             <button
//               className="btn btn-secondary"
//               onClick={() => navigate(-1)}
//             >
//               بازگشت
//             </button>
//           </div>
//         </>
//       </div>
//     </>
//   ) : (
//     <Loading color="#7545fb" />
//   );
// };

import React, { useState, useEffect, useContext, useMemo } from 'react';
import styles from './EditeGroup.module.scss';
import copyStyleNewUser from '../../../shared/NewUserModal.module.scss';
import { myUserDataContext } from '../../../App';
import { responseHandler } from '../../../functions/responseHandler';
import { notify } from '../../../functions/toasts';
import 'react-toastify/dist/ReactToastify.css';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Loading from '../../../shared/Loading';
import { debounce } from 'lodash';
import CustomSelect from 'react-select';

const mergeOptions = (prev, next) => {
  const map = new Map((prev || []).map((o) => [o.value, o]));
  (next || []).forEach((o) => map.set(o.value, o));
  return Array.from(map.values());
};

const EditeGroup = () => {
  const params = useParams();
  const navigate = useNavigate();

  const data = useContext(myUserDataContext);
  const { userData, UpdateLocalStorage, setUpdateLocalStorage, isLogin } = data;
  const { token } = userData;

  const [checkBtnEdite, setCheckBtnEdite] = useState(false);
  const [isLoad, setIsLoad] = useState(true);

  const [title, setTitle] = useState('');
  const [selectedUsers, setSelectedUsers] = useState([]); 
  const [users, setUsers] = useState([]); 
  const [selectedUserOptions, setSelectedUserOptions] = useState([]); 

  // ---------- fetch users for select (append, not replace) ----------
  const fetchUsers = async (name = '') => {
    try {
      const url = name
        ? `/user/list-for-select?last_name=${encodeURIComponent(name)}`
        : `/user/list-for-select`;

      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data.status) {
        const options = res.data.data.map((item) => ({
          label: `${item.first_name} ${item.last_name}`,
          value: item.id,
        }));

        setUsers((prev) => mergeOptions(prev, options));
      }
    } catch (err) {
      responseHandler(err, 'error');
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  // ---------- debounce ----------
  const debouncedFetchUsers = useMemo(
    () =>
      debounce((value) => {
        if ((value || '').length >= 2) fetchUsers(value);
      }, 1000),
    [token],
  );

  useEffect(() => {
    return () => {
      debouncedFetchUsers.cancel();
    };
  }, [debouncedFetchUsers]);

  const handleInputChangeUser = (value) => {
    debouncedFetchUsers(value);
  };

  const handleChangeUser = (selectedOption) => {
    const opts = Array.isArray(selectedOption)
      ? selectedOption
      : selectedOption
      ? [selectedOption]
      : [];

    setSelectedUserOptions(opts);
    setSelectedUsers(opts.map((o) => o.value));

    setUsers((prev) => mergeOptions(prev, opts));
  };

  // ---------- get group data for edit ----------
  useEffect(() => {
    const runGet = async () => {
      try {
        const res = await axios.get(
          `/access-group/show/${params.id}?relations[]=users`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );

        if (res.data.status) {
          setTitle(res.data.data.title);

          const selectedOpts = (res.data.data.users || []).map((u) => ({
            value: u.id,
            label: `${u.first_name} ${u.last_name}`,
          }));

          setSelectedUsers(selectedOpts.map((x) => x.value));
          setSelectedUserOptions(selectedOpts);

          setUsers((prev) => mergeOptions(prev, selectedOpts));
        }
      } catch (error) {
        responseHandler(error, 'error', false);
        if (error.response?.status === 404)
          navigate('/notfound', { replace: true });
      }
    };

    runGet();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!selectedUsers.length) {
      setSelectedUserOptions([]);
      return;
    }

    const found = users.filter((opt) => selectedUsers.includes(opt.value));
    if (found.length) {
      setSelectedUserOptions((prev) => mergeOptions(prev, found));
    }
  }, [users, selectedUsers]);

  const inputHandler = (e) => setTitle(e.target.value);

  // ---------- submit ----------
  const editeUserHandler = async () => {
    setCheckBtnEdite(true);

    if (title === '' || selectedUsers.length === 0) {
      notify('برخی از موارد خواسته شده وارد نشده اند', 'error');
      setCheckBtnEdite(false);
      return;
    }

    const bodyUpdateGroup = {
      title,
      users: selectedUsers,
    };

    try {
      const res = await axios.put(
        `/access-group/update/${params.id}`,
        bodyUpdateGroup,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      responseHandler(res, 'succ');

      if (res.data.status) {
        try {
          const res2 = await axios.get(`/access-group/show/${params.id}`, {
            headers: { Authorization: `Bearer ${token}` },
          });

          if (res2.data.status) {
            setUpdateLocalStorage(!UpdateLocalStorage);
            navigate('/dashboard/groups');
          }
        } catch (error) {
          responseHandler(error, 'error');
          setIsLoad(false);
        }
      }

      setIsLoad(false);
      setCheckBtnEdite(false);
    } catch (error) {
      responseHandler(error, 'error');
      setCheckBtnEdite(false);
    }
  };

  return isLogin ? (
    <>
      <div className={styles.EditeUserDiv}>
        <div className={styles.title}>
          <span>{`ویرایش ${title}`}</span>
          <i className="bi bi-person-fill-gear"></i>
        </div>

        <div className={styles.InputsDiv}>
          <div className={copyStyleNewUser.Inputs}>
            <label htmlFor="nameEdite">نام:</label>
            <input
              type="text"
              id="nameEdite"
              name="title"
              value={title}
              onChange={inputHandler}
            />
          </div>

          <div>
            <div style={{ marginBottom: 200 }}>
              <CustomSelect
                isMulti
                options={users}
                value={selectedUserOptions}
                placeholder="کاربر را انتخاب کنید"
                onInputChange={handleInputChangeUser}
                onChange={handleChangeUser}
                isClearable
                isSearchable
              />
            </div>
          </div>
        </div>

        <div className={`${styles.btns} d-grid gap-2 col-6 mx-auto mt-5`}>
          <button
            className="btn btn-primary"
            disabled={checkBtnEdite}
            onClick={editeUserHandler}
          >
            ویرایش
            {checkBtnEdite && (
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              />
            )}
          </button>

          <button className="btn btn-secondary" onClick={() => navigate(-1)}>
            بازگشت
          </button>
        </div>
      </div>
    </>
  ) : (
    <Loading color="#7545fb" />
  );
};

export default EditeGroup;
